import { NavLink } from 'react-router-dom'
import {
  Boxes,
  Brain,
  Database,
  HardDrive,
  LayoutDashboard,
  LogOut,
  Puzzle,
  Settings,
  Sparkles,
} from 'lucide-react'
import { useAuthStore } from '../store/auth'

const nav = [
  { path: '/', label: 'Resumen', icon: LayoutDashboard },
  { path: '/db', label: 'OrzDB', icon: Database },
  { path: '/projects', label: 'Proyectos', icon: Boxes },
  { path: '/storage', label: 'OrzStorage', icon: HardDrive },
  { path: '/ai', label: 'OrzAI', icon: Brain },
  { path: '/mcp', label: 'MCP', icon: Puzzle },
  { path: '/settings', label: 'Ajustes', icon: Settings },
]

export function Layout({ children }: { children: React.ReactNode }) {
  const logout = useAuthStore((s) => s.logout)

  async function handleLogout() {
    await logout()
    window.location.href = '/login'
  }

  return (
    <div className="flex h-screen bg-surface text-gray-100">
      <aside className="flex w-64 flex-col border-r border-white/10 bg-panel">
        <div className="flex items-center gap-3 px-6 py-5">
          <div className="flex h-9 w-9 items-center justify-center rounded-lg bg-gradient-to-br from-brand-500 to-brand-700 shadow-lg shadow-brand-500/20">
            <Sparkles className="h-5 w-5 text-white" />
          </div>
          <span className="text-lg font-bold tracking-tight">OrzForge</span>
        </div>

        <nav className="flex-1 space-y-1 px-3 py-4">
          {nav.map((item) => (
            <NavLink
              key={item.path}
              to={item.path}
              end={item.path === '/'}
              className={({ isActive }) =>
                `flex items-center gap-3 rounded-lg px-3 py-2.5 text-sm font-medium transition-colors ${
                  isActive
                    ? 'bg-brand-500/15 text-brand-300'
                    : 'text-gray-400 hover:bg-white/5 hover:text-gray-100'
                }`
              }
            >
              <item.icon className="h-4 w-4" />
              {item.label}
            </NavLink>
          ))}
        </nav>

        <div className="border-t border-white/10 p-3">
          <button
            onClick={handleLogout}
            className="flex w-full items-center gap-3 rounded-lg px-3 py-2.5 text-sm font-medium text-gray-400 transition-colors hover:bg-red-500/10 hover:text-red-400"
          >
            <LogOut className="h-4 w-4" />
            Cerrar sesión
          </button>
        </div>
      </aside>

      <main className="flex-1 overflow-auto">
        <div className="mx-auto max-w-7xl p-6 lg:p-8">{children}</div>
      </main>
    </div>
  )
}
